import { FC } from "react";
import { SwitchProps, SWITCH_SIZES } from "./types";
import { SwitchLabel, SwitchToggle, useSwitch, useSwitchStyles } from ".";

const Switch: FC<SwitchProps> = ({
  checked,
  onClick,
  label,
  size = SWITCH_SIZES.MEDIUM,
  disabled,
}) => {
  const { dimensions, handleClick, circlePosition, textClass } = useSwitch(
    size,
    checked,
    onClick,
    disabled
  );

  const { containerClassName, circleClassName, labelClassName } =
    useSwitchStyles(checked, disabled);

  return (
    <div className="flex gap-2 w-auto h-auto">
      <SwitchToggle
        dimensions={dimensions}
        circlePosition={circlePosition}
        containerClassName={containerClassName}
        circleClassName={circleClassName}
        onClick={handleClick}
      />

      {label && (
        <SwitchLabel
          label={label}
          textClass={textClass}
          labelClassName={labelClassName}
        />
      )}
    </div>
  );
};

export default Switch;
